import { assign, forEach, isArray, isObject, isString, keys, mapValues } from "lodash";

import Dimensions from "../constants/styles/dimensions";
import batchUtils from "../modules/batchUtils";
import { characterWidthMapOperations, characterWidthMapSelectors } from "../modules/characterWidthMap";
import rootActionTypes from "../modules/rootActionTypes";

// TODO: Add handling of arabic characters

// Note: dropped back to measuring a single character, because this is "safer" for
// Arabic text (where characters change size depending on position in a word, but standalone
// characters are typically largest).
// This doesn't appear to have a negative effect on English characters yet, but this is something
// to be aware of...
const NUM_CHARS_TO_MEASURE = 1; //20;

// TODO: To make this more efficient, we could have a list of actions that will contain text properties we need to
// check, but it will be even more susceptible to becoming out of date than this list.

// const relevantctionTypes = [
//   itemActionTypes.EDIT_LABEL,
//   itemActionTypes.EDIT_SUMMARY,
// ];

// TODO: In future, we should not actively measure known fixed-width chars (e.g. Chinese characters), and
// instead just keep the known sizes for those character sets. That way, we won't have to measure text too
// often, and won't be updating our character width map table as often (triggering re-calcs of items etc.)

const relevantCharKeys = {
  label: true,
  initials: true,
  summary: true,
  value: true,
  replaceValue: true,
  name: true,
  newValue: true,
  plural: true,
  prefix: true,
  description: true,
  tags: true
};

const findCharsInObjectOrArrayWithKeys = (node, nodeKey, ignoreChars, findKeys) => {
  let result = {};
  forEach(node, (value, key) => {
    if (isString(value) && (findKeys[key] || (isArray(node) && findKeys[nodeKey]))) {
      [...value].forEach(c => {
        if (!ignoreChars[c]) {
          result[c] = true;
        }
      });
    } else if (isArray(value) || isObject(value)) {
      assign(result, findCharsInObjectOrArrayWithKeys(value, key, ignoreChars, findKeys));
    }
  });
  return result;
};

export default store => next => action => {
  const prevState = store.getState();
  const existingCharMap = characterWidthMapSelectors.getCharacterWidthMap(prevState.present).toObject();
  const newChars = keys(findCharsInObjectOrArrayWithKeys(action, null, existingCharMap, relevantCharKeys));

  let finalAction = action;

  // If there are new characters that we need to handle
  if (newChars.length) {
    // Render them in a secret div
    let wrapperDiv = document.createElement("div");
    wrapperDiv.style.position = "fixed";
    wrapperDiv.style.left = "0px";
    wrapperDiv.style.top = "0px";
    wrapperDiv.style.visibility = "hidden";
    wrapperDiv.style.zIndex = -1;
    wrapperDiv.style.minWidth = "500px";
    wrapperDiv.style.display = "flex";
    wrapperDiv.style.flexDirection = "column";
    wrapperDiv.style.justifyItems = "flex-start";
    wrapperDiv.style.alignItems = "flex-start";

    let spanForChar = {};

    newChars.forEach(char => {
      spanForChar[char] = document.createElement("span");
      spanForChar[char].textContent = char.repeat(NUM_CHARS_TO_MEASURE);
      spanForChar[char].style.fontSize = `${Dimensions.BASE_FONT_SIZE}px`;
      spanForChar[char].style.fontWeight = "normal";
      spanForChar[char].style.fontStyle = "normal";
      spanForChar[char].style.display = "inline-block";
      wrapperDiv.appendChild(spanForChar[char]);
    });

    // Once we have created all of our divs, add them to the document
    document.body.appendChild(wrapperDiv);

    const widthMap = mapValues(spanForChar, el => {
      return Number((el.getBoundingClientRect().width / NUM_CHARS_TO_MEASURE).toFixed(2));
    });

    wrapperDiv.remove();

    // We have to handle a special case of LOAD_FILE being called, as this is setup outside of the
    // batch process, and so it cannot handle being included in a batch statement.
    // Therefore, in that one instance, we need to execute the reducer once with the original LOAD_FILE
    // call, and then again with the update character widths
    if (
      action.type === rootActionTypes.LOAD_FILE ||
      action.type === rootActionTypes.UPDATE_FILE ||
      action.type === rootActionTypes.LOAD_SAMPLE
    ) {
      // Combine existing char map with new values
      const charWidthMap = Object.assign(existingCharMap, widthMap);
      // Append them into the action
      finalAction = Object.assign({}, action, { charWidthMap });
    } else {
      // Normally, we can just apply a batch with the character update included with the normal actions
      // Generate the action that will save character widths
      const charAction = characterWidthMapOperations.addCharacterWidths(widthMap);
      finalAction = batchUtils.batchWithAppendedActions(action, charAction);
    }
  }
  return next(finalAction);
};
